module.exports = __webpack_public_path__ + "img/Form1.23e92aaa.png";